"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/inherits"));
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _withStyles = _interopRequireDefault(require("@mui/styles/withStyles"));
var _HiIconButton = _interopRequireDefault(require("../HiIconButton"));
var _RemoveRedEye = _interopRequireDefault(require("@mui/icons-material/RemoveRedEye"));
var _Delete = _interopRequireDefault(require("@mui/icons-material/Delete"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var styles = exports.styles = function styles(theme) {
  return {
    root: (0, _objectSpread2.default)({
      position: 'relative'
    }, theme.typography.body2, {
      borderBottom: "1px solid ".concat(theme.palette.input.bottomLine),
      paddingLeft: 8,
      backgroundColor: theme.palette.background2,
      height: 40,
      display: 'inline-flex',
      justifyContent: 'flex-start',
      cursor: 'pointer',
      '&$focused, &$dragOver': {
        backgroundColor: theme.palette.background1
      },
      width: '100%',
      // Ajout d'1px pour ne pas avoir de décalage en mode error avec le border top
      '&:not($error)': {
        marginTop: 1
      }
    }),
    underline: {
      '&:before': {
        left: 0,
        bottom: 0,
        // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
        content: '""',
        height: 1,
        position: 'absolute',
        right: 0,
        transition: theme.transitions.create('background-color', {
          duration: theme.transitions.duration.shorter,
          easing: theme.transitions.easing.ease
        }),
        pointerEvents: 'none' // Transparent to the hover style.
      },
      '&:hover:not($disabled):before': {
        backgroundColor: theme.palette.input.bottomLine,
        height: 2
      },
      '&$disabled:before': {
        background: 'transparent',
        backgroundImage: "linear-gradient(to right, ".concat(theme.palette.input.bottomLine, " 33%, transparent 0%)"),
        backgroundPosition: 'left top',
        backgroundRepeat: 'repeat-x',
        backgroundSize: '5px 1px'
      }
    },
    inkbar: {
      '&:not($disabled)': {
        '&:not($error):after': {
          backgroundColor: theme.palette.primary.main,
          left: 0,
          bottom: 0,
          // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
          content: '""',
          height: 1,
          position: 'absolute',
          right: 0,
          transform: 'scaleX(0)',
          transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
          }),
          pointerEvents: 'none' // Transparent to the hover style.
        },
        '&:hover:after': {
          transform: 'scaleX(1)'
        },
        '&$dragOver:after': {
          transform: 'scaleX(1)'
        },
        '&$focused:after': {
          transform: 'scaleX(1)'
        },
        '&$error': {
          borderBottom: "1px solid ".concat(theme.palette.error.main)
        }
      }
    },
    disabled: {
      color: "".concat(theme.palette.action.disabled),
      '&:before': {
        display: 'none'
      },
      cursor: 'default'
    },
    focused: {
      backgroundColor: theme.palette.background3
    },
    error: {},
    label: (0, _objectSpread2.default)({}, theme.typography.body2, {
      caretColor: theme.palette.primary.main,
      alignItems: 'center',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      padding: "calc(".concat(theme.spacing(2) - 2, "px 0 ").concat(theme.spacing(2), " - 1px)"),
      height: 39,
      display: 'inline-flex',
      width: '100%',
      cursor: 'pointer',
      '&$empty': {
        opacity: 0.42
      }
    }),
    empty: {},
    dragOver: {},
    droppable: {},
    endAdornment: {
      display: 'flex',
      alignItems: 'center'
    },
    icon: {
      display: 'inline-flex',
      alignItems: 'center',
      right: 0,
      padding: '8px',
      color: "".concat(theme.palette.text.icon),
      fontSize: 10,
      transition: theme.transitions.create(['opacity', 'transform'], {
        duration: theme.transitions.duration.shorter
      }),
      '&:hover': {
        color: 'inherit',
        background: 'none'
      }
    }
  };
};
var _ref = /*#__PURE__*/_react.default.createElement(_RemoveRedEye.default, null);
var _ref2 = /*#__PURE__*/_react.default.createElement(_Delete.default, null);
var HiUploadInput = /*#__PURE__*/function (_React$Component) {
  function HiUploadInput(props) {
    var _this;
    (0, _classCallCheck2.default)(this, HiUploadInput);
    _this = _callSuper(this, HiUploadInput, [props]);
    // Action when files are dropped on the field
    _this.handleDrop = function (event) {
      if (event.target === _this.uploadFieldRef) {
        event.preventDefault();
        event.stopPropagation();
        if (_this.state.droppable) {
          var param = _this.handleFile(event.dataTransfer.files);
          _this.setState({
            dragOver: false
          });
          _this.props.onChange(param, _this.props.index);
        } else {
          _this.setState({
            errorMessage: _this.props.translations.errorDropMultiple,
            dragOver: false
          });
        }
      }
    };
    // Action when files are dragged over the field.
    _this.handleDragEnter = function (event) {
      event.preventDefault();
      event.stopPropagation();
      if (event.target === _this.uploadFieldRef) {
        if (event.dataTransfer.items.length !== 1) {
          event.dataTransfer.dropEffect = 'none';
          _this.props.onChange({
            errorMessage: _this.props.translations.errorDragEnter,
            value: null
          }, _this.props.index);
          _this.setState({
            dragOver: true
          });
        } else {
          _this.setState({
            droppable: true,
            dragOver: true
          });
        }
      }
    };
    // Action when files are not dragged over the field anymore.
    _this.handleDragLeave = function (event) {
      event.preventDefault();
      event.stopPropagation();
      if (event.target === _this.uploadFieldRef && event.relatedTarget.parentElement !== _this.uploadFieldRef) {
        _this.props.onChange({
          errorMessage: '',
          value: null
        }, _this.props.index);
        _this.setState({
          droppable: false,
          dragOver: false
        });
      }
    };
    _this.handleChange = function (event) {
      var param = _this.handleFile(event.target.files);
      _this.props.onChange(param, _this.props.index);
    };
    _this.handleDeleteFile = function () {
      _this.props.onDeleteFile(_this.props.index);
    };
    _this.handleEmptyField = function (event) {
      event.target.value = '';
    };
    _this.handleSeeFile = function () {
      _this.props.onSeeFile(_this.props.value);
    };
    // Handles the file wether it is selected via the input or dropped on it.
    _this.handleFile = function (files) {
      var error = false;
      var errorMessage = '';
      var file = null;
      if (files.length === 1) {
        file = files[0];
        errorMessage = '';
        if (file.size > _this.props.maxSize) {
          errorMessage += _this.props.translations.errorSize.replace('maxSize', _this.props.maxSize / 1000000);
          error = true;
        }
        if (_this.props.acceptedTypes.length !== 0 && _this.props.acceptedTypes.indexOf(file.type) === -1) {
          errorMessage += _this.props.translations.errorType;
          error = true;
        }
      } else {
        errorMessage = _this.props.translations.errorDropMultiple;
      }
      return {
        errorMessage: errorMessage,
        error: error,
        value: file
      };
    };
    _this.uploadFieldRef = void 0;
    _this.state = {
      errorMessage: '',
      dragOver: false,
      droppable: false
    };
    return _this;
  }

  // When component mounts, we add eventListeners to handle the file drag and drop
  (0, _inherits2.default)(HiUploadInput, _React$Component);
  return (0, _createClass2.default)(HiUploadInput, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.uploadFieldRef.addEventListener('dragenter', this.handleDragEnter, false);
      this.uploadFieldRef.addEventListener('dragleave', this.handleDragLeave, false);
      this.uploadFieldRef.addEventListener('dragover', function (event) {
        event.preventDefault();
      }, false);
      this.uploadFieldRef.addEventListener('drop', this.handleDrop, false);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.uploadFieldRef.removeEventListener('dragenter', this.handleDragEnter, false);
      this.uploadFieldRef.removeEventListener('dragleave', this.handleDragLeave, false);
      this.uploadFieldRef.removeEventListener('dragover', function (event) {
        event.preventDefault();
      }, false);
      this.uploadFieldRef.removeEventListener('drop', this.handleDrop, false);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        placeholder = _this$props.placeholder,
        classes = _this$props.classes,
        disabled = _this$props.disabled,
        focused = _this$props.focused,
        value = _this$props.value,
        error = _this$props.error;
      var _this$state = this.state,
        dragOver = _this$state.dragOver,
        errorMessage = _this$state.errorMessage,
        droppable = _this$state.droppable; // On utilise classNames pour variabiliser les styles et merger les classes appliquées
      var rootClass = (0, _classnames.default)(classes.root, classes.inkbar, classes.underline, (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, classes.disabled, disabled), classes.focused, focused), classes.error, error && !focused), classes.dragOver, dragOver), classes.droppable, droppable));
      var eyeButton = /*#__PURE__*/_react.default.createElement(_HiIconButton.default, {
        className: classes.icon,
        onClick: this.handleSeeFile
      }, _ref);
      return /*#__PURE__*/_react.default.createElement("div", {
        className: rootClass
      }, /*#__PURE__*/_react.default.createElement("label", {
        className: (0, _classnames.default)(classes.label, (0, _defineProperty2.default)({}, classes.empty, value === null)),
        ref: function ref(label) {
          _this2.uploadFieldRef = label;
        }
      }, value ? value.name : error && errorMessage || placeholder, /*#__PURE__*/_react.default.createElement("input", {
        type: 'file',
        onClick: this.handleEmptyField,
        hidden: true,
        onChange: this.handleChange
      })), value === null || /*#__PURE__*/_react.default.createElement("div", {
        className: classes.endAdornment
      }, this.props.seeFile && eyeButton, /*#__PURE__*/_react.default.createElement(_HiIconButton.default, {
        className: classes.icon,
        onClick: this.handleDeleteFile
      }, _ref2)));
    }
  }]);
}(_react.default.Component);
HiUploadInput.defaultProps = {
  placeholder: 'Choose a file',
  disabled: false,
  focused: false,
  acceptedTypes: [],
  maxSize: 10000000,
  value: null,
  translations: {
    errorSize: "Votre fichier est trop lourd. Nous acceptons jusqu'à maxSizeMo",
    errorDropMultiple: 'Veuillez insérer un et un seul fichier',
    errorType: "Ce type de fichier n'est pas accepté",
    errorDragEnter: 'Contenu non correct'
  }
};
var _default = exports.default = (0, _withStyles.default)(styles, {
  hiComponent: true,
  name: 'HmuiHiUploadInput'
})(HiUploadInput);